export default function(child, parent) {
  var proto = (child.prototype = Object.create(parent.prototype));
  proto.constructor = child;
  return proto;
}



// WEBPACK FOOTER //
// ./~/vega-util/src/inherits.js